import { getDatabase, ref, update } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { formatDateForStorage } from '../Helpers/DateUtils';
import { recordActivity } from './activityApi';

/**
 * Records activity for the signed-in user so "Senast aktiv" reflects web usage,
 * not just iOS app launches, and logs a `session.started` entry in the
 * Användaraktivitet log (collapsed within 15 minutes). Writes the shared
 * `lastActive` field on `users/userList/{uid}` (the same field the iOS app writes).
 *
 * Best-effort: activity tracking must never block or break the app, so failures
 * are logged and swallowed.
 */
export async function markCurrentUserActive(): Promise<void> {
    const user = getAuth().currentUser;
    if (!user) return;

    recordActivity('session.started');

    try {
        const db = getDatabase();
        await update(ref(db, `users/userList/${user.uid}`), {
            lastActive: formatDateForStorage(new Date()),
        });
    } catch (error) {
        console.error('Kunde inte uppdatera senast aktiv:', error);
    }
}
